import { Component, OnInit, Inject } from '@angular/core';
import { DocumentService } from 'src/app/Service/document/document.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDocumentMailInputModel, IDocumentMailOutputModel } from 'src/app/ViewModel/DocumentModel';

@Component({
  selector: 'app-schedule-document-mail-list',
  templateUrl: './schedule-document-mail-list.component.html',
  styleUrls: ['./schedule-document-mail-list.component.css']
})
export class ScheduleDocumentMailListComponent implements OnInit {
  public mailList: IDocumentMailOutputModel[] = [];
  public filteredList: IDocumentMailOutputModel[] = [];
  public docNo: string = '';
  public selectedMailType: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ScheduleDocumentMailListComponent>,
    private _docService: DocumentService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: IDocumentMailInputModel
  ) { }

  ngOnInit() {
    if (this._data != null) {
      this.docNo = this._data.DocumentNo;
      this.selectedMailType = this._data.Category;
      this.initGrid();
    }
  }

  public async initGrid() {
    this.mailList = await this._docService.getDocumentMsgList(this._data.DocId, this._data.ProjectId, this._data.GroupId, this._data.MemberId, this._data.TransType, this._data.revisionNo).toPromise();
      if (this._data.Category == 2) {
      this.filteredList = this.mailList.filter(x => x.messageCategory == 3);
    }
    else {
      this.filteredList = this.mailList.filter(x => x.messageCategory != 3);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  filterMailType(event: any) {  
    if (event.value == 2) {
      this.filteredList = this.mailList.filter(x => x.messageCategory == 3);
    }
    else {
      this.filteredList = this.mailList.filter(x => x.messageCategory != 3);
    }
  }

}
